import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import DetailHeader from '../Parts/DetailHeader';

/**
 * 報告書詳細ページのヘッダーコンポーネント
 *
 * - ヘッダーには、タイトルと、戻るボタンが表示される
 * - 戻るボタンをクリックすると、レポートの一覧ページに遷移する
 * @returns {ReactElement}
 */
const ReportDetailHeader = ({ onBack }) => (
  <DetailHeader
    title={<FormattedMessage id="report.detail.title" />}
    onBack={onBack}
  />
);

ReportDetailHeader.propTypes = {
  onBack: PropTypes.func.isRequired,
};

export default ReportDetailHeader;
